export default (object) => {
    let str = '?';
    for (var key in object) {
        if (object.hasOwnProperty(key)) {
            var element = object[key];
            if (element) {
              str = `${str}${key}=${element}&`;
            }
        }
    }
    return str.substring(0, str.length - 1);
}